<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import SalesRepForm from "@distributor/svelte/Employees/SalesRepForm.svelte";
  import SalesRepRetailers from "@distributor/svelte/Employees/SalesRepRetailers.svelte";
  import SalesRepActionButtons from "@distributor/svelte/Employees/SalesRepActionButtons.svelte";
  import SearchRetailerAndAddBox from "@distributor/svelte/Employees/SearchRetailerAndAddBox.svelte";

  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";

  import type { SalesRep } from "@shared/types/SalesRep";

  export let salesRep: SalesRep;

  let currentUserRole = $DistributorStore.currentDistributor?.role;
  let assigned =
    ["distributor_admin", "payments_admin"].includes(currentUserRole) ||
    !!salesRep.current_user_managed_reps?.find(rep => rep.id === salesRep.id);
</script>

<FizzStyles>
  <div class="fizz-inset-square-32">
    <div class="fizz-surface fizz-stack-24">
      <div class="fizz-container fizz-flex-row fizz-space-between">
        <h3 class="fizz-heading-3">{salesRep.name}</h3>
        <SalesRepActionButtons {salesRep} bind:assigned {currentUserRole} />
      </div>
    </div>
    <div class="fizz-container">
      <div class="fizz-flex-row fizz-justify-center fizz-stack-12">
        <SalesRepForm bind:salesRep {currentUserRole} bind:assigned />
      </div>
    </div>
    <div class="fizz-surface fizz-stack-24">
      <div class="fizz-container fizz-inset-vertical-16">
        <h3 class="fizz-heading-3 fizz-surface" class:fizz-stack-12={!assigned}>Retailers</h3>
        {#if assigned}
          <div
            class="fizz-flex-row-responsive fizz-inset-vertical-16"
            data-testid="retailer-assignment-search"
          >
            <SearchRetailerAndAddBox {salesRep} />
          </div>
        {/if}
        <SalesRepRetailers {salesRep} bind:assigned />
      </div>
    </div>
  </div>
</FizzStyles>
